import { Close, PlayArrow, Replay } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useRef, useState } from 'react';

interface Props {
    src: string,
    onClose?: (e: any) => void,
}

function VideoBox(props : Props) {
    const { src, onClose } = props;
    const [play, setPlay] = useState(false);
    const [played, setPlayed ] = useState(false); 
    const videoRef = useRef<HTMLVideoElement>(null);

    const playVideo = () => {
        if (videoRef && videoRef.current) {
            videoRef.current.play();
        }
    }

    return <Box sx={{ position: 'relative', width: '100%' }}>
        <video style={{ width: '100%', maxHeight: '80vh' }} ref={videoRef} autoPlay={true} onPlay={() => setPlay(true)} onEnded={() => {setPlayed(true); setPlay(false);}}>
            <source src={src} type={"video/mp4"}/>
        </video>
        {!play && <Button sx={{ position: 'absolute', bottom: '50%', left: '50%', transform: 'translate(-50%, 50%)', width: '96px', height: '96px', borderRadius: '30px' }} variant='contained' onClick={() => playVideo()}>
            <Replay sx={{ height: '64px', width: '64px' }}/>
        </Button>}
        {played && <Button sx={{ position: 'absolute', bottom: '0px', left: '50%', transform: 'translate(-50%, 25%)', width: '48px', height: '64px', borderRadius: '20px' }} variant='contained' onClick={onClose}>
            <Close/>
        </Button>}
    </Box>;
}

export default VideoBox;